import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  campaign: validator('presence', true),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class MlpVoucherModel extends Model.extend(Validations) {
  // Attributes
  @attr('string') campaign;
  @attr('string') text;

  // Relations
  @belongsTo('product', { async: true, inverse: null }) product;
}
